import { render, staticRenderFns } from "./NonIndividualAffiliationsTab.vue?vue&type=template&id=f1f27f18&scoped=true&"
import script from "./NonIndividualAffiliationsTab.vue?vue&type=script&lang=js&"
export * from "./NonIndividualAffiliationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f27f18",
  null
  
)

export default component.exports